module.exports = __webpack_public_path__ + "img/VM24_6470.b798aee5.jpg";